export const getSitename = () => {
	return 'Spotlyst';
};
